import { render } from "./ExportPDF.vue?vue&type=template&id=1ddd94da"
import script from "./ExportPDF.vue?vue&type=script&lang=js"
export * from "./ExportPDF.vue?vue&type=script&lang=js"

import exportComponent from "/Users/quentinpuechguiral/Documents/inProgress/patentidea.web3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__